import AjaxPromises from '../utils/AjaxPromises';

import { endPoints as EndPoints } from '../constants/PosConstants';

export default {

    loadFullGuest:(formData) => {
        return AjaxPromises.POST(EndPoints.LOAD_FULL_GUEST, formData);
    },

    search:(formData) => {
        return AjaxPromises.POST(EndPoints.POS_PRODUCT_SEARCH, formData);
    },

    loadProducts:(formData) => {
        return AjaxPromises.POST(EndPoints.GET_PRODUCTS, formData);
    },

    productHistory:(formData) => {
        return AjaxPromises.POST(EndPoints.PRODUCT_HISTORY, formData);
    },

    transactionHistory:(formData) => {
        return AjaxPromises.POST(EndPoints.TRANSACTION_HISTORY, formData);
    },

    loadProductInformation:(formData) => {
        return AjaxPromises.POST(EndPoints.PRODUCT_DETAILS, formData);
    },

    loadAvailableDiscounts:(formData) => {
        return AjaxPromises.POST(EndPoints.AVAILABLE_DISCOUNTS, formData);
    },
    
    getAvailabelLabels:(formData) => {
        return AjaxPromises.POST(EndPoints.GET_AVAILABLE_LABELS, formData);
    },

    // loadAvailableFeesDonations:(formData) => {
    //     return AjaxPromises.POST(EndPoints.AVAILABLE_FEES_DONATIONS, formData);
    // },

    // getCalculationMethods:() => {
    //     return AjaxPromises.POST(EndPoints.GET_CALCULATION_METHODS);
    // },

    getAvailableReceiptPrinters: (formData) => {
        return AjaxPromises.POST(EndPoints.GET_AVAILABLE_RECEIPT_PRINTERS, formData);
    },

    getAvailableLabelPrinters: (formData) => {
        return AjaxPromises.POST(EndPoints.GET_AVAILABLE_LABEL_PRINTERS, formData);
    },

    productSearch:(formData) => {
        return AjaxPromises.POST(EndPoints.POS_PRODUCT_SEARCH, formData);
    },

    loadAppliedDiscounts:(formData) => {
        return AjaxPromises.POST(EndPoints.APPLIED_DISCOUNTS, formData);
    },

    // loadItemsByCategory:(formData) => {
    //     return AjaxPromises.POST(EndPoints.LOAD_ITEMS_BY_CATEGORY, formData);
    // }
}



// WEBPACK FOOTER //
// ./ui_src/app/api/PosApi.jsx